export const GET_FILE_TYPE = {
    INIT: "GET_FILE_TYPE_INIT",
    SUCCESS: "GET_FILE_TYPE_SUCCESS",
    ERROR: "GET_FILE_TYPE_ERROR",
};

export const GET_FILE_UPLOAD_LOGS = {
    INIT: "GET_FILE_UPLOAD_LOGS_INIT",
    SUCCESS: "GET_FILE_UPLOAD_LOGS_SUCCESS",
    ERROR: "GET_FILE_UPLOAD_LOGS_ERROR",
};

export const GET_RESE_CUSTOM_FILE_NAME = {
    INIT: 'GET_RESE_CUSTOM_FILE_NAME_INIT',
    SUCCESS: 'GET_RESE_CUSTOM_FILE_NAME_SUCCESS',
    ERROR: 'GET_RESE_CUSTOM_FILE_NAME_ERROR'
}

export const GET_RESE_CUSTOM_FILE_CONTENT = {
    INIT: 'GET_RESE_CUSTOM_FILE_CONTENT_INIT',
    SUCCESS: 'GET_RESE_CUSTOM_FILE_CONTENT_SUCCESS',
    ERROR: 'GET_RESE_CUSTOM_FILE_CONTENT_ERROR'
}